import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { AppState } from '../../global/types';
import { SettingsPageState } from './types';

const initialState: SettingsPageState = {
  getConfig: {
    data: null,
    loading: false,
    error: null,
  },
  getCardPayment: {
    data: null,
    loading: false,
    error: null,
  },
  getGlovoEnabledStatus: {
    data: {
      status: null,
    },
    loading: false,
    error: null,
  },
  getDeliveryProviders: {
    data: null,
    loading: false,
    error: null,
  },
};

const reducer = createReducer(initialState, {
  [actions.getConfig.REQUEST]: (state) => {
    state.getConfig.loading = true;
  },

  [actions.getConfig.SUCCESS]: (state, action) => {
    state.getConfig.loading = false;
    state.getConfig.data = action.payload;
  },

  [actions.getConfig.ERROR]: (state, action) => {
    state.getConfig.loading = false;
    state.getConfig.error = action.payload;
  },
  [actions.getCardPayment.REQUEST]: (state) => {
    state.getCardPayment.loading = true;
  },

  [actions.getCardPayment.SUCCESS]: (state, action) => {
    state.getCardPayment.loading = false;
    state.getCardPayment.data = action.payload;
  },

  [actions.getCardPayment.ERROR]: (state, action) => {
    state.getCardPayment.loading = false;
    state.getCardPayment.error = action.payload;
  },
  [actions.getGlovoEnabledStatus.REQUEST]: (state) => {
    state.getGlovoEnabledStatus.loading = true;
  },

  [actions.getGlovoEnabledStatus.SUCCESS]: (state, action) => {
    state.getGlovoEnabledStatus.loading = false;
    state.getGlovoEnabledStatus.data.status = !action.payload.all_closed;
    if (action.payload.until) {
      state.getGlovoEnabledStatus.data.until = action.payload.until;
    }
  },

  [actions.getGlovoEnabledStatus.ERROR]: (state, action) => {
    state.getGlovoEnabledStatus.loading = false;
    state.getGlovoEnabledStatus.error = action.payload;
  },

  [actions.getDeliveryProviders.REQUEST]: (state) => {
    state.getDeliveryProviders.loading = true;
  },

  [actions.getDeliveryProviders.SUCCESS]: (state, action) => {
    state.getDeliveryProviders.loading = false;
    state.getDeliveryProviders.data = action.payload;
  },

  [actions.getDeliveryProviders.ERROR]: (state, action) => {
    state.getDeliveryProviders.loading = false;
    state.getDeliveryProviders.error = action.payload;
  },
});

const config = (state: AppState) => state.settingsPageReducer.getConfig.data;
const cardPayment = (state: AppState) =>
  state.settingsPageReducer.getCardPayment.data;
const glovoEnabled = (state: AppState) =>
  state.settingsPageReducer.getGlovoEnabledStatus.data;
const deliveryProviders = (state: AppState) =>
  state.settingsPageReducer.getDeliveryProviders.data;

const selectors = {
  config,
  cardPayment,
  glovoEnabled,
  deliveryProviders,
};

export { selectors };
export default reducer;
